
import React from 'react';
import styles from "./index.module.scss";

import iSafe from "@/modules/tm/assets/detail/safe-shield.png";

export interface ITMDetailPictureAreaProps {
  name: string;
  mainPicture?: string;
  pictures?: string[];
}

const TMDetailPictureArea: React.FC<ITMDetailPictureAreaProps> =  (props) => {
  return (
    <div className={`${styles.container} flex-col flex-cross-axis-center`}>
      <img className={styles.mainPicture} src={props.mainPicture} alt={props.name} />
      <div className={`${styles.noticeContainer} flex-row flex-cross-axis-center`}>
        <img className={styles.safeIcon} src={iSafe} alt="" />
        <div className={styles.text}>国家商标局备案机构，安全保障</div>
      </div>
    </div>
  )
}

export default TMDetailPictureArea
